var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkGreenBig = function SvgCheckmarkGreenBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m151.734 40.889-88.755 88.749-35.307-35.307-7.228 7.227 42.535 42.534 95.982-95.976-7.227-7.227Z",
    fill: "#18BD4E"
  })));
};
export { SvgCheckmarkGreenBig as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTg0IiBoZWlnaHQ9IjE4NCIgdmlld0JveD0iMCAwIDE4NCAxODQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUxLjczNCA0MC44ODg5TDYyLjk3OTEgMTI5LjYzOEwyNy42NzE2IDk0LjMzMDdMMjAuNDQ0NCAxMDEuNTU4TDYyLjk3OTEgMTQ0LjA5MkwxNTguOTYxIDQ4LjExNkwxNTEuNzM0IDQwLjg4ODlaIiBmaWxsPSIjMThCRDRFIi8+Cjwvc3ZnPgo=";